import React, { useState, useEffect, useRef } from 'react';

const CanvasImage = ({ canvasImg }) => {
    const canvasRef = useRef(null);
    const [hovered, setHovered] = useState(false);

    useEffect(() => {
        const canvas = canvasRef.current;
        const ctx = canvas.getContext('2d');
        const img = new Image();
        img.src = './img/system/sorinosk1.png';

        let frame = 0;
        let animationFrameId = null;

        const drawImage = () => {
            if (!canvas || !ctx || !img.complete) 
            {
                return;
            }

            const dpr = window.devicePixelRatio || 1
            const parent = canvas.parentElement;
            const width = parent.clientWidth;
            const height = parent.clientHeight;

            canvas.width = width*dpr;
            canvas.height = height*dpr;
            canvas.style.width = `${width}px`;
            canvas.style.height = `${height}px`;

            ctx.setTransform(dpr, 0, 0, dpr, 0, 0); // Handles DPI scaling cleanly
            ctx.clearRect(0, 0, width, height);

            // Set amplitude of the float
            const floatAmplitude = hovered ? 10 : 0;

            // Use sine wave for smooth float
            const floatProgress = Math.sin(frame / 30); // Range: -1 to 1
            const floatY = floatAmplitude * floatProgress;

            // Normalize floatY to 0 (top) → 1 (bottom)
            const floatNormalized = (floatProgress + 1) / 2; // Range: 0 to 1

            // Shadow gets bigger when image is lower
            const ovalScale = hovered ? 0.9 + floatNormalized * 0.3 : 1; // Range: 0.9 to 1.2 (adjust as needed)

            // Compute scaled size while keeping aspect ratio
            const scale = Math.min(0.8 * width / img.width, 0.8 * height / img.height);
            const imgWidth = img.width * scale;
            const imgHeight = img.height * scale;

            const x = (width - imgWidth) / 2;
            const y = floatY;

            const imgSize = Math.min(imgWidth, imgHeight) * 0.6;
            
            // Draw shadow (oval)
            const shadowOffsetX = 0;
            const shadowOffsetY = imgHeight/2;
            const ovalWidth = imgSize * 0.7;
            const ovalHeight = imgSize * 0.15;
            const ovalX = (width - ovalWidth*ovalScale) / 2 + shadowOffsetX;
            const ovalY = y + imgSize + shadowOffsetY - floatY;

            // Draw shadow
            ctx.beginPath();
            ctx.ellipse(
                ovalX + ovalWidth * ovalScale / 2,
                ovalY,
                ovalWidth * ovalScale / 2,
                ovalHeight * ovalScale / 2,
                0,
                0,
                2 * Math.PI
            );
            ctx.fillStyle = 'rgba(0, 0, 0, 0.2)';
            ctx.fill();

            ctx.drawImage(img, x, y, imgWidth, imgHeight);

            frame++;
            animationFrameId = requestAnimationFrame(drawImage);
        };

        img.onload = () => {
            drawImage();
            window.addEventListener('resize', drawImage);
        };
        
        return () => {
            cancelAnimationFrame(animationFrameId);
            window.removeEventListener('resize', drawImage)
        };
    }, [hovered]);

    return (
        <canvas
            ref={canvasRef}
            className={canvasImg}
            style={{ width: '100%', height: '100%' }}
            onContextMenu={(e) => e.preventDefault()}
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
        />
    );
};

export default CanvasImage